import {useState, useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {message} from 'antd';
import {getAllClients, selectClients, setPage, selectPage, selectLoaded, setLoaded, selectTotalUsers} from '../../redux/slices/clients';
import ClientsUI from './components/ClientsUI';
import exportClients from '../../utils/exportClients';

const Clients = () => {
  const loaded = useSelector(selectLoaded);
  const [loading, handleLoading] = useState(!loaded);
  const clients = useSelector(selectClients);
  const page = useSelector(selectPage);
  const [perPage, setPerPage] = useState(20)
  const dispatch = useDispatch();
  const totalUsers = useSelector(selectTotalUsers);

  const filtersRef = useRef({
    name: "",
    email: "",
    phone: "",
    estado: "",
  });

  useEffect(() => {
  let cancelled = false;
  (async () => {
    handleLoading(true);
    const response = await dispatch(getAllClients(page, filtersRef.current, perPage));
    if (cancelled) return;
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
    handleLoading(false);
    dispatch(setLoaded(true));
})();
  return () => {
    cancelled = true;
  };
}, [dispatch, page, perPage]);

  const exportData = () => {
    exportClients(clients);
  };

  const handlePage = newPage => {
    dispatch(setPage(newPage));
  };

  const applyFilters = () => {
    if (page !== 1) {
      dispatch(setPage(1))
    }
    else {
      dispatch(getAllClients(1, filtersRef.current, perPage))
    }
  }

  const handleTableChange = (pagination, tableFilters) => {
    const nextPerPage = pagination?.pageSize ?? perPage;
    if (nextPerPage !== perPage){
      setPerPage(nextPerPage);
      dispatch(setPage(1));
    }
    const active = tableFilters?.active?.[0];
    filtersRef.current.estado = active === undefined || active === null ? "" : String(active);

    if (nextPerPage === perPage) applyFilters();
  }

  return (
    <ClientsUI
      loading={loading}
      clients={clients}
      exportData={exportData}
      page={page}
      perPage={perPage}
      handlePage={handlePage}
      totalUsers={totalUsers}
      filtersRef={filtersRef}
      applyFilters={applyFilters}
      onTableChange={handleTableChange}
    />
  );
}

export default Clients;
